
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/[listingAlias]/rental-application",
      function () {
        return require("private-next-pages/listing/[listingAlias]/rental-application/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing/[listingAlias]/rental-application"])
      });
    }
  